const neighborhoods = [
  { name: "Downtown Johnson City", desc: "Historic East Main, ETSU campus corridor, and the Arts District. Home to Mountain States Medical District and the city's cultural core.", icon: "ri-building-line" },
  { name: "Jonesborough", desc: "Tennessee's oldest town and Washington County seat. Just 9 miles southwest — the National Storytelling Festival draws international visitors annually.", icon: "ri-map-pin-line" },
  { name: "Gray / Gray Station", desc: "Fast-growing suburb north of Johnson City along I-26. Hospital City of Gray includes Johnson City Medical Center and Niswonger Children's Hospital.", icon: "ri-hospital-line" },
  { name: "Boones Creek", desc: "Eastern Johnson City suburb along US-11E. Families and professionals commuting to the Tri-Cities Regional Airport and surrounding industrial parks.", icon: "ri-flight-takeoff-line" },
  { name: "Elizabethton", desc: "Carter County neighbor 8 miles south. Home to Roan Mountain hikers and manufacturers traveling to European partner plants.", icon: "ri-tree-line" },
  { name: "Unicoi / Erwin", desc: "Unicoi County gateway 12 miles south. Outdoor adventure hub for the Nolichucky River corridor with a growing international mountain biking circuit.", icon: "ri-landscape-line" },
];

const employers = [
  { name: "East Tennessee State University", desc: "14,000+ students and 2,400 employees. Study abroad programs, international faculty, and global research partnerships drive consistent passport demand.", icon: "ri-graduation-cap-line" },
  { name: "Mountain States Health Alliance", desc: "Johnson City Medical Center, Niswonger Children's Hospital, and 13 affiliated facilities. Physicians attending WHO summits and international medical conferences.", icon: "ri-hospital-line" },
  { name: "Ballad Health", desc: "Major regional health system serving 29 counties across TN and VA. Medical executives attending international health leadership summits.", icon: "ri-heart-pulse-line" },
  { name: "Eastman Chemical (nearby)", desc: "10-mile neighbor in Kingsport with 7,000+ area employees. Many Johnson City residents commute to Eastman and travel internationally on business.", icon: "ri-flask-line" },
];

export default function JohnsonCityLocalAreaSection() {
  return (
    <section id="local-area" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Local Coverage</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Serving Johnson City & Washington County
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            From downtown ETSU to Jonesborough, from Gray to Elizabethton — we cover all of Northeast Tennessee's Tri-Cities region.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          <div>
            <h3 className="font-serif text-2xl font-bold text-[#1A365D] mb-6">Areas We Serve</h3>
            <div className="space-y-4">
              {neighborhoods.map((n, i) => (
                <div key={i} className="flex items-start gap-4 p-5 bg-[#F7F8FA] rounded-xl">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#EEF2F8] flex-shrink-0">
                    <i className={`${n.icon} text-[#1A365D] text-lg`}></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-[#1A365D] mb-1">{n.name}</h4>
                    <p className="text-gray-500 text-sm leading-relaxed">{n.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div>
            <h3 className="font-serif text-2xl font-bold text-[#1A365D] mb-6">Major Employers We Serve</h3>
            <div className="space-y-4 mb-8">
              {employers.map((e, i) => (
                <div key={i} className="flex items-start gap-4 p-5 bg-[#F7F8FA] rounded-xl">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#EEF2F8] flex-shrink-0">
                    <i className={`${e.icon} text-[#1A365D] text-lg`}></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-[#1A365D] mb-1">{e.name}</h4>
                    <p className="text-gray-500 text-sm leading-relaxed">{e.desc}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="bg-[#1A365D] rounded-xl p-6">
              <h4 className="font-semibold text-white mb-3">Tri-Cities Regional Airport (TRI)</h4>
              <p className="text-white/70 text-sm leading-relaxed mb-4">
                Johnson City's primary airport serves as a regional hub to major international gateways — Charlotte (CLT), Atlanta (ATL), Chicago (ORD), and Washington Dulles (IAD). All connections require a valid passport for international travel beyond domestic hubs.
              </p>
              <div className="flex items-center gap-2 text-[#F6C344] text-sm font-medium">
                <i className="ri-flight-takeoff-line"></i>
                <span>15 minutes from downtown Johnson City</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}